/**
 * BottomTabBar — Mobile navigation bar.
 * Previously inline in App.tsx (lines 937-958).
 */
import React from 'react';
import { BookOpen, Target, Trophy, Bot, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUIStore, type TabId } from '../stores';

const TABS: { id: TabId; icon: React.ElementType; labelKey: string }[] = [
  { id: 'learn', icon: BookOpen, labelKey: 'Lernen' },
  { id: 'exam', icon: Target, labelKey: 'Prüfung' },
  { id: 'leaderboard', icon: Trophy, labelKey: 'Rangliste' },
  { id: 'chat', icon: Bot, labelKey: 'Coach' },
  { id: 'profile', icon: User, labelKey: 'Profil' },
];

const BottomTabBar: React.FC = () => {
  const { t } = useTranslation();
  const activeTab = useUIStore((s) => s.activeTab);
  const setActiveTab = useUIStore((s) => s.setActiveTab);

  return (
    <div
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md px-4 z-40 pointer-events-none"
      style={{ paddingBottom: 'max(0.85rem, env(safe-area-inset-bottom))' }}
    >
      <nav className="glass-nav pointer-events-auto flex justify-around items-stretch gap-1 p-1.5">
        {TABS.map(({ id, icon: Icon, labelKey }) => {
          const active = activeTab === id;
          return (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              aria-current={active ? 'page' : undefined}
              className={`flex flex-1 flex-col items-center gap-1 rounded-[1.25rem] py-2 transition-all active:scale-95 ${
                active
                  ? 'text-primary bg-white/45 dark:bg-white/10 shadow-[inset_0_1px_0_var(--f-glass-highlight)]'
                  : 'text-[var(--f-text-tertiary)] hover:text-[var(--f-text-secondary)]'
              }`}
            >
              <Icon size={23} strokeWidth={active ? 2.5 : 2} />
              <span className="text-[10px] font-bold leading-none">{t(labelKey)}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default BottomTabBar;
